import type { TeamRole } from "@/lib/types";

const TEAM_ROLE_LABELS: Record<TeamRole, string> = {
  team_admin: "Team administrator",
  coach: "Coach",
  assistant_coach: "Assistant coach",
  player: "Player",
  guardian: "Parent / guardian",
  viewer: "Viewer",
};

export function teamRoleLabel(role: TeamRole): string {
  return TEAM_ROLE_LABELS[role];
}
